$(document).ready(function() {
    if ($(".mxm_courses").length) {

        let $fields = $(".mxm_courses-fields");
        let $login = $(".mxm_courses-login");

        $(".mxm_courses .datepicker").each(function() {
            $(this).datepicker();
            $(this).datepicker( "option", "dateFormat", 'dd.mm.yy');
            var val = $(this)[0].defaultValue;

            if (val && val != "") {
                $(this).datepicker("setDate", val);
            }
        });

        $('input[type=radio][name=mxm_courses-odaorg]').change(function() {
            switch(this.value) {
                case "0":
                    $fields.removeClass("hidden");
                    $login.addClass("hidden");
                    break;
                case "1":
                    $login.removeClass("hidden");
                    $fields.addClass("hidden");
                    break;
            }
        });
    }

    $(".clearFile").on('click', function(e) {
        e.preventDefault();
        var $btn = $(e.currentTarget);
        var $file = $btn.prev();
        $file.val('');
    })

    $('.form-control-course').select2();
    var groupselect = $('.group-billing .form-control-course').select2({
        tags: true,
        width: '100%'
    });

    var fields = [
        "G_FIRMA",
        "G_FIRMAZUSATZ",
        "G_ADRESSE",
        "G_ZUSATZ",
        "G_PLZ",
        "G_ORT"
    ]

    var isPredefinedPrev = false;
    var isPredefined = false;
    var isFormError = false;

    groupselect.on("select2:select", function (e) {
        var companyVal = $(e.currentTarget).val();

        isPredefined = /^\d+$/.test(companyVal);
        isFormError = $('.formerror').length;

        if (isPredefined) {
            $.ajax({
                type: 'GET',
                url: '/wp-json/mxm_courses/company',
                data: { "companyid": companyVal },
                beforeSend: function () {
                    loadingStart();
                }
            })
                .done(function (result) {
                    if (!result) {
                        showError(result);
                    } else {
                        fillFields(result);
                    }
                })
                .fail(function (result) {
                    showError(result);
                })
                .always(function () {
                    loadingStop();
                });
        } else {
            if (typeChanged()) {
                clearFields();
            }
            copyValue(companyVal);
        }
        isPredefinedPrev = isPredefined;
    });

    function copyValue(companyVal) {
        $('input[name="G_FIRMA"]').val(companyVal);
    }

    function typeChanged() {
        return isPredefinedPrev != isPredefined;
    }

    function fillFields(result) {
        for (let i = 0; i < fields.length; i++) {
            const field = fields[i];
            if (result[field] && result[field] != "") {
                $('input[name="'+field+'"]').val(result[field]).attr("readonly", true);
            } else {
                $('input[name="' + field + '"]').val("").attr("readonly", false);
            }
        }
    }

    function clearFields() {
        for (let i = 0; i < fields.length; i++) {
            const field = fields[i];
            $('input[name="'+field+'"]').val("").attr("readonly", false);
        }
    }

    function showError(result) {
        var errorMsg = result;
        groupselect.closest('.form-group').prepend('<div id="billing-error" class="error"><div class="help-block">Diese Geschäftsadresse können wir gerade nicht ausfindig machen. Bitte versuchen Sie es noch einmal.</div></div>');
        console.warn('ajax error or id not found');
        clearFields();
        groupselect.val(null).trigger('change');
    }

    function loadingStart() {
        groupselect.closest('.row').addClass('loading');
        groupselect.closest('.form-group').prepend('<div id="billing-loading" class="progress showing"><div class="indeterminate"></div></div>');
    }

    function loadingStop() {
        groupselect.closest('.row').removeClass('loading')
        $('#billing-loading').detach().remove();
    }
})



/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/courses/index.js
 **/